import { IOrg } from '@/store/types';
import Axios from 'axios';

const RESOURCE = '/api/a';

export default {
  listOrgs(): IOrg[] {
    // @ts-ignore
    return Axios.get(`${RESOURCE}/o`);
  },
  listIssues(): any[] {
    // @ts-ignore
    return Axios.get(`${RESOURCE}/issues`);
  },
  materializedRevenue(): any[] {
    // @ts-ignore
    return Axios.get(`${RESOURCE}/real-revenue`);
  },
  adminSetOrgSetting(orgId: string, setting: string, value: boolean): any {
    // @ts-ignore
    return Axios.post(`${RESOURCE}/update-org-setting`, { orgId, setting, value });
  },
};
